// extracted by mini-css-extract-plugin
export default {"modal":"I_-z","modalContent":"J_-z","footer":"K_-z","cancelBtn":"L_-z","disabled":"M_-z","formWrapper":"N_-z","fade":"O_-z","fade-in":"P_-z","iframe":"Q_-z"};